// @flow
import * as React from 'react'
import { withRouter } from 'next/router'
import type { BookInfoType } from '../../models/Book'
import { getBooksListPropsAsync } from '../../models/Book'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { DiscoverMenu } from '@components/Discover/DiscoverMenu'
import { BookInfo } from '@components/Book/BookInfo'
import styled from 'styled-components'
import { colors } from '@components/shared'
import { config } from 'react-awesome-styled-grid'
function Books (props: {books: BookInfoType[]}): React.Node {
  return (
    <DiscoverLayout background title={'Explore Romance Books on Dipsea'}>
      <div>
        <DiscoverMenu page={'read'}/>
        {props.books.map((book: BookInfoType): React.Node => (
          <SectionDivider key={`book-${book.id}`}><BookInfo {...book}/></SectionDivider>
        ))}
      </div>
    </DiscoverLayout>
  )
}
export default withRouter(Books)

export async function getStaticProps (): Promise<{ props: {books: BookInfoType[] } }> {
  const books = await getBooksListPropsAsync()
  return { props: { books } }
}

const SectionDivider = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid ${colors.white25};
  ${(props: any): string => config(props).media.md`
    padding: 30px 0;
  `}
`
